import { render } from "./Styleguide-Specimen.vue?vue&type=template&id=50169573"
import script from "./Styleguide-Specimen.vue?vue&type=script&lang=js"
export * from "./Styleguide-Specimen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__